import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
export default {
  name: 'ArrowLink',
  components: {
    MdmLink: MdmLink
  },
  props: {
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};